var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarBlueIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.07 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000000;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Zas\xF3b 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17,44a1,1,0,1,0,0,2h5v3a1,1,0,1,0,2,0V46h7v3a1,1,0,1,0,2,0V46h7v3a1,1,0,1,0,2,0V46h5a1,1,0,1,0,0-2H42V37.23h5a1,1,0,1,0,0-2H42V28h5a1,1,0,1,0,0-2H42V19.06a1,1,0,1,0-2,0V26H33V19.06a1,1,0,1,0-2,0V26H24V19.09a1,1,0,1,0-2,0V26H17a1,1,0,1,0,0,2h5v7.23H17a1,1,0,1,0,0,2h5V44Zm23,0H33V37.23h7Zm0-16v7.23H33V28ZM24,28h7v7.23H24Zm0,9.23h7V44H24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52,46.55A7.51,7.51,0,0,1,44.51,54H12V16H10V44.68A9.35,9.35,0,0,1,1,54H.94a1,1,0,0,0,0,2H10v2.58A1.42,1.42,0,0,0,11.42,60H52.59A1.42,1.42,0,0,0,54,58.58V16H52V46.55ZM7.05,54a11.41,11.41,0,0,0,3-2.93V54Zm45,4H12V56H44.51A9.48,9.48,0,0,0,52,52.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.64,4H50V3a3,3,0,0,0-3-3h-.79a3,3,0,0,0-3,3V4H35.33V3a3,3,0,0,0-3-3h-.79a3,3,0,0,0-3,3V4H20.8V3a3,3,0,0,0-3-3H17a3,3,0,0,0-3,3V4H9.43A1.42,1.42,0,0,0,8,5.42v7.17A1.42,1.42,0,0,0,9.43,14H54.65a1.42,1.42,0,0,0,1.42-1.42V5.42A1.43,1.43,0,0,0,54.64,4ZM45.21,3a1,1,0,0,1,1-1H47a1,1,0,0,1,1,1V6.16a1,1,0,0,1-1,1h-.79a1,1,0,0,1-1-1ZM30.54,3a1,1,0,0,1,1-1h.79a1,1,0,0,1,1,1V6.16a1,1,0,0,1-1,1h-.79a1,1,0,0,1-1-1ZM16,3a1,1,0,0,1,1-1h.79a1,1,0,0,1,1,1V6.16a1,1,0,0,1-1,1H17a1,1,0,0,1-1-1Zm38.06,9H10V6h4v.16a3,3,0,0,0,3,3h.79a3,3,0,0,0,3-3V6h7.74v.16a3,3,0,0,0,3,3h.79a3,3,0,0,0,3-3V6H43.2v.16a3,3,0,0,0,3,3H47a3,3,0,0,0,3-3V6h4.06v6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlueIco);
export default __webpack_public_path__ + "static/media/calendar-blue-ico.d2bc8c60121788d20e7a1a48f19d328e.svg";
export { ForwardRef as ReactComponent };